import { render, staticRenderFns } from "./EmployeesBoard.vue?vue&type=template&id=193f5a3c&scoped=true&"
import script from "./EmployeesBoard.vue?vue&type=script&lang=ts&"
export * from "./EmployeesBoard.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeesBoard.vue?vue&type=style&index=0&id=193f5a3c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f5a3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VList,VListItem,VRow})
